import React from "react";
import {Form, Modal, Spinner} from "react-bootstrap";
import BaseModalSmall from "../BaseModalSmall";
import {useDispatch, useSelector} from "react-redux";
import {actionChangeInputsModalSurvey, handleOpenModalSurvey} from "../../../../../redux/actions/modals/modalSurvey";
import axios from "axios";
import {BASE_URL, POLLS_REGISTER_POST} from "../../../../../apis";
import qs from "querystring";
import swal from 'sweetalert';
import StarRatings from 'react-star-ratings';
import {
    actionChangeTextSurveyRealTime,
} from "../../../../../redux/actions/modals/myOrders/modalMyOrders";

const ModalSurvey = () => {
    const {statusShow, order, rate, comment,loader} = useSelector(state => state.modalSurvey);
    const {token} = useSelector(state => state.user);
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(handleOpenModalSurvey(false, null));
    };

    const handleSendSurvey = () => {
        if (validateForm()) {
            dispatch(actionChangeInputsModalSurvey('loader', true));
            axios({
                method: 'post',
                url: BASE_URL + POLLS_REGISTER_POST,
                data: qs.stringify({order, rate, comment}),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
            }).then((response) => {
                if (response.data.status === 'ok') {
                    handleClose();
                    dispatch(actionChangeTextSurveyRealTime(order,response.data.button_text));
                    swal({
                        title: "ثبت موفق",
                        text: "سپاس، نظر شما با موفقیت ثبت گردید.",
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "success",
                    });
                } else {
                    showModalError();
                }
                dispatch(actionChangeInputsModalSurvey('loader', false));
            }).catch(() => {
                showModalError();
                dispatch(actionChangeInputsModalSurvey('loader', false));
            });
        }
    };

    const validateForm = () => {
        if (order) {
            return true;
        } else {
            showModalError();
            return false;
        }
    };

    const showModalError = () => {
        swal({
            title: "خطا",
            text: "لطفا مجددا تلاش کنید.",
            buttons: {
                cancel: "تایید",
            },
            icon: "error",
        });
    };

    const handleChangeInputsModalSurvey = (event) => {
        const {name, value} = event.target;
        dispatch(actionChangeInputsModalSurvey(name, value));
    };

    const handleChangeRating = (newRating, name) => {
        if (newRating < 3) {
            dispatch(actionChangeInputsModalSurvey('comment', ''));
        }
        dispatch(actionChangeInputsModalSurvey(name, newRating));
    };

    return (
        <BaseModalSmall title={'نظرسنجی'}
                        show={statusShow}
                        dialogClassName={'custom-modal-survey'}
                        handleClose={handleClose}>
            <Modal.Body>
                <div>
                    <p>با نطرات شما خدمات ما بهتر خواهد شد.</p>
                    <p>سفارش چطور بود ؟</p>
                </div>
                <div dir={'ltr'} className={'mb-3'}>
                    <StarRatings
                        rating={rate}
                        starDimension="40px"
                        starSpacing="10px"
                        starRatedColor="orange"
                        changeRating={handleChangeRating}
                        name={'rate'}
                        starHoverColor={'#fdd835'}
                    />
                </div>
                <Form onSubmit={handleSendSurvey}>
                    {/*<Form.Group className={'box-input-modal-survey'} controlId="input-form-send-survey" style={{height:rate <= 3 ?120 : 0}}>
                        <Form.Control name={'comment'} as="textarea" rows={4}
                                      value={comment} onChange={handleChangeInputsModalSurvey}
                                      placeholder="لطفا نظر خود را در اینجا بنویسید..."/>
                    </Form.Group>*/}
                    <Form.Group className={'box-input-modal-survey'} controlId="input-form-send-survey">
                        <Form.Control name={'comment'} as="textarea" rows={4}
                                      value={comment} onChange={handleChangeInputsModalSurvey}
                                      placeholder="لطفا نظر خود را در اینجا بنویسید..."/>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <button className={'btn btn-block'} onClick={handleSendSurvey} disabled={loader}>
                    <span>ثبت</span>
                    {loader ?
                        <div className={'d-inline-block'}><Spinner className={'mb-1 ml-2'} animation="border"
                                                                   size="sm" variant="danger"/></div> : ''}
                </button>
            </Modal.Footer>
        </BaseModalSmall>
    );
};

export default React.memo(ModalSurvey);
